import {mapActions, mapGetters, mapMutations} from 'vuex';

const _ = require('lodash');

// Ключі i18n для пунктів меню: стабільні, не залежать від мови.
// Поле `name` у config.js не чіпаємо — бекенд матчить права саме по ньому (item_name).
const menuI18nKeys = {
    desktop: 'menu.desktop',
    users_group: 'menu.contacts_users_group',
    users: 'menu.contacts_users',
    department: 'menu.contacts_department',
    'customer-groups': 'menu.contacts_customer_groups',
    customers: 'menu.contacts_customers',
    'status-orders': 'menu.orders_statuses',
    'type-orders': 'menu.orders_payment_methods',
    'orders-list': 'menu.orders_list',
    'type-delivery': 'menu.orders_delivery_methods',
    'product-category': 'menu.catalog_categories',
    products: 'menu.catalog_products',
    manufacturer: 'menu.catalog_manufacturers',
    sites: 'menu.catalog_sites',
    material: 'menu.catalog_materials',
    model: 'menu.catalog_model',
    'shipment-list': 'menu.shipment_list',
    'registers-novaposhta': 'menu.shipment_registers_np',
    warehouse: 'menu.warehouse_list',
    'warehouse-products': 'menu.warehouse_stocks',
    provisioners: 'menu.warehouse_provisioners',
    lots: 'menu.warehouse_income',
    'movement-products': 'menu.warehouse_movement',
    'sms-templates': 'menu.templates_sms',
    plugins: 'menu.plugins_list',
    stats_orders: 'menu.statistics_orders',
    'lack-of': 'menu.statistics_lack',
    rate: 'menu.rate_rate',
    'sms-list': 'menu.mailing_sms',
    1: 'menu.contacts',
    2: 'menu.orders',
    3: 'menu.catalog',
    4: 'menu.shipment',
    5: 'menu.warehouse',
    6: 'menu.templates',
    7: 'menu.plugins',
    8: 'menu.statistics',
    9: 'menu.rate',
    10: 'menu.mailing',
};

export default {
    data(){
      return{
          newMenuList: null
      }
    },
    computed: {
        ...mapGetters({
            menuList:'config/menuList',
            menuHide:'config/menuHide',
            openMenuItem:'config/openMenuItem',
            colNewOrders:'orders/colNewOrders',
            profile:'profile/profile',
            usersGroup: 'contacts/usersGroup',

        })
    },
    watch:{
        usersGroup(e){
            if(this.profile){
                let userGroup = e.data.filter(item=>item.id === this.profile.user_group_id)
                userGroup = userGroup[0];
                this.newMenuList = _.clone(this.menuList);

                this.newMenuList.map(menuItem => {
                    let colValueTrue = 0;
                    if(menuItem.list){
                        menuItem.list.map(listItem=>{
                            userGroup.accept_to_menu_items.map(item=>{
                                if(listItem.name === item.item_name){
                                    listItem.value = item.value
                                }
                                if(listItem.value){
                                    colValueTrue++;
                                }
                            })
                        })
                        menuItem.value = colValueTrue;
                    }
                })
                this.newMenuList[0].value = 1;
                return userGroup;
            }
        }
    },
    created() {
        this.getOrders().then(()=>{
            this.getUsersGroup();
        });

    },
    methods:{
        menuLabel(item) {
            const key = menuI18nKeys[item.link] || menuI18nKeys[item.id];
            return key && this.$te(key) ? this.$t(key) : item.name;
        },
        showMenuList(id){
            this.changeOpenMenuItem(id);
            this.toggleMenuHide(false);
        },
        toggleSideBar(){
            this.changeOpenMenuItem(0);
            this.toggleMenuHide(!this.menuHide);
        },
        ...mapActions({
            getOrders:'orders/getOrders',
            getUsersGroup:'contacts/getUsersGroup',
        }),
        ...mapMutations({
            toggleMenuHide:'config/toggleMenuHide',
            changeOpenMenuItem:'config/changeOpenMenuItem',
        })
    }
}
